// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","874":"component---src-pages-call-details-tsx"}[chunkId] + "-" + {"245":"1d27034d52877437480a","453":"4a2424bb0f7658aef1cf","874":"52f821e10c9ec04d4664"}[chunkId] + ".js";
};